module.exports = __webpack_public_path__ + "img/Ellipse1.5bfa0b0a.png";